




























import { Vue, Component, Prop } from 'vue-property-decorator';
import { AvatarSize } from '@getaccept/lib-ui';
import { ChatHelper } from '@getaccept/lib-shared/src/chat/helpers/chat.helper';
import ChatMessageOther from '@getaccept/lib-shared/src/chat/components/ChatMessageOther.vue';
import ChatMessageSender from '@getaccept/lib-shared/src/chat/components/ChatMessageSender.vue';
import ChatTimestamp from '@getaccept/lib-shared/src/chat/components/ChatTimestamp.vue';
import type { Comment } from '@getaccept/lib-shared/src/chat/types/comment';
import type { SigningPageUser } from '@getaccept/lib-shared/src/types/signing-page-user';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';

@Component({
  components: {
    ChatMessageSender,
    ChatMessageOther,
    ChatTimestamp,
  },
  data: () => ({
    ChatHelper,
    AvatarSize,
  }),
  computed: {
    name(): string {
      return ChatHelper.getFullname(this.comment, this.sender, this.recipients);
    },
    thumbUrl(): string {
      return ChatHelper.getThumbUrl(this.comment, this.recipients);
    },
    date(): string {
      return ChatHelper.date(this.comment.createdAt);
    },
    time(): string {
      return ChatHelper.time(this.comment.createdAt);
    },
    fullTimestamp(): string {
      return ChatHelper.fullTimestamp(this.comment.createdAt);
    },
    showTimestamp(): boolean {
      return ChatHelper.showTimestamp(this.previousComment, this.comment.createdAt);
    },
    previousComment(): Comment {
      return ChatHelper.getPreviousComment(this.comment, this.comments);
    },
    nextComment(): Comment {
      return ChatHelper.getNextComment(this.comment, this.comments);
    },
    lastComment(): Comment {
      return ChatHelper.getLastComment(this.comments);
    },
    isLastCommentInMonologue(): boolean {
      return ChatHelper.isLastCommentInMonologue(
        this.comment,
        this.lastComment.id,
        this.nextComment
      );
    },
    isFirstCommentInMonologue(): boolean {
      return ChatHelper.isFirstCommentInMonologue(this.previousComment, this.comment);
    },
    isFirstCommentInBlock(): boolean {
      return ChatHelper.isFirstCommentInBlock(this.previousComment, this.comment);
    },
    isByActiveRecipient(): boolean {
      if (this.comment.userId) {
        return false;
      }
      return ChatHelper.isByActiveRecipient(this.comment, this.recipientId);
    },
  },
})
export default class ChatComment extends Vue {
  @Prop() comment!: Comment;
  @Prop() comments!: Comment[];
  @Prop() recipients: SigningPageRecipient[];
  @Prop() sender!: SigningPageUser;
  @Prop() recipientId!: string;

  showMessageTimestamp = false;

  clickOutside() {
    this.toggleMessageTimestamp(false);
  }

  toggleMessageTimestamp(show: boolean) {
    this.showMessageTimestamp = show;
  }
}
